import { Badge } from "@/shared/ui/badge";
import type { QueueItem } from "../types";

const SEV_LABEL: Record<string, string> = { critical: "Critical", high: "High", medium: "Medium", low: "Low" };

/** Variant A only: shows OUR assessment so the client reacts to it (anchored). */
export function OurClassification({ item }: { item: QueueItem }) {
  if (!item.our) {
    return (
      <div className="rounded-lg border border-border/50 bg-muted/20 p-3">
        <p className="text-xs uppercase tracking-wide text-muted-foreground">Our assessment</p>
        <p className="mt-1 font-medium text-foreground">No deficiency — this looks fine to us.</p>
      </div>
    );
  }
  return (
    <div className="rounded-lg border border-border/50 bg-muted/20 p-3">
      <p className="text-xs uppercase tracking-wide text-muted-foreground">Our assessment</p>
      <p className="mt-1 font-medium text-foreground">{item.our.title}</p>
      {item.our.detail && <p className="text-sm text-muted-foreground">{item.our.detail}</p>}
      {item.our.severity && (
        <div className="mt-2">
          <Badge variant="secondary">Severity: {SEV_LABEL[item.our.severity]}</Badge>
        </div>
      )}
    </div>
  );
}
